import classNames from "classnames";
import React from "react";

interface CalendarBlockLegendProps {
  size: 'small' | 'big';
  onWhiteBg?: boolean;
  fullAnnotation?: string;
  notFullAnnotation?: string;
}

export const CalendarBlockLegend: React.FC<CalendarBlockLegendProps> = ({
  notFullAnnotation,
  fullAnnotation,
  size,
  onWhiteBg = false
}) => {
  return (
    <div className={classNames("calendar-block-legend", {
      "calendar-block-legend--whiteBg": !onWhiteBg,
      "calendar-block-legend--small": size === 'small',
      "calendar-block-legend--big": size === 'big',
    })}>
      <div className="calendar-block-legend__segment calendar-block-legend__segment--available">
        {notFullAnnotation ?? "Ledig"}
      </div>
      {size === 'small' && (
        <div className="calendar-block-legend__separator">/</div>
      )}
      <div className="calendar-block-legend__segment calendar-block-legend__segment--notAvailable">
        {fullAnnotation ?? "Fullt"}
      </div>
    </div>
  );
};
